export default __webpack_public_path__ + "static/media/IkonGrafer.0ba240af.svg";